import { Button } from '@printdeal/ui-library';
import { FormattedMessage } from 'react-intl';
import React, { useState } from 'react';
import { GuidedSellingModal } from './GuidedSellingModal';
import { dispatchDataLayerEntry } from '../../../helpers/dataLayerHelpers/productDataLayerHelper';

interface Props {
  pageName: string;
  contentfulId: string;
  title?: string;
}

export const GuidedSellingBanner = ({ pageName, contentfulId, title }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleStartDecisionAssistanceClick = () => {
    setIsOpen(true);
    dispatchDataLayerEntry(pageName, 'click_start_decision_assistance', {
      contentfulId,
      title,
    });
  };

  return (
    <div className="pd-grid pd-gap-8">
      <div className="pd-flex pd-items-center pd-justify-center pd-gap-3 pd-rounded-md pd-bg-dim-100 pd-py-4">
        <span className="pd-font-semibold pd-text-dim-800">
          <FormattedMessage id="general.chooseProduct.advice.text" defaultMessage="Do you need help in choosing a product?" />
        </span>
        <Button onClick={handleStartDecisionAssistanceClick}>
          <FormattedMessage id="general.chooseProduct.decisionAssistance.buttonText" defaultMessage="Start decision assistance" />
        </Button>
      </div>
      <GuidedSellingModal isOpen={isOpen} setIsOpen={setIsOpen} />
    </div>
  );
};
